/* Product page behaviour.
 *
 * Everything here is an upgrade on markup that already works without it:
 *   - the variant <select> is the real form control; the chips drive it
 *   - the gallery is a scroll-snap rail; thumbs and dots are anchor links
 *
 * Arrival windows live in arrival-window.js — the cart needs them too.
 *
 * If this file fails to load, the page still sells a shirt.
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var select = form.querySelector('[data-variant-select]');
  var variants = [];
  try {
    variants = JSON.parse(form.getAttribute('data-variants')) || [];
  } catch (e) {
    variants = [];
  }

  var moneyFormat = null;

  function formatMoney(cents) {
    // Shopify hands us the shop's format at render time via the first price we
    // saw; fall back to a plain dollar figure rather than guessing a locale.
    if (moneyFormat) return moneyFormat(cents);
    return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
  }

  /* ── Gallery ────────────────────────────────────────────────────────── */

  var rail = document.querySelector('[data-gallery-rail]');
  var markers = Array.prototype.slice.call(
    document.querySelectorAll('[data-thumb], [data-dot]')
  );

  // Distance from the rail's current scroll position to the slide, measured off
  // bounding rects. offsetLeft is measured against the nearest *positioned*
  // ancestor, which is not the rail — it silently includes the gallery's own
  // page offset. Scroll snapping hid that, landing on the right slide by luck
  // for short jumps and the wrong one for long ones.
  function railDeltaTo(slide) {
    return slide.getBoundingClientRect().left - rail.getBoundingClientRect().left;
  }

  function scrollRailTo(slide) {
    if (!rail || !slide) return;
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollTo({
      left: rail.scrollLeft + railDeltaTo(slide),
      behavior: smooth ? 'smooth' : 'auto',
    });
  }

  // Bring a specific photo into the frame by its Shopify image id. Used when a
  // colour is picked: the swatch and the photo are the same decision, so the
  // main image should follow the swatch rather than making you hunt the thumbs.
  function showImageById(imageId) {
    if (!rail || !imageId) return;
    var slide = rail.querySelector('[data-image-id="' + imageId + '"]');
    if (!slide) return;
    // Already showing it — a size change keeps the same photo, and scrolling a
    // rail that is already in place just makes the page twitch.
    if (Math.abs(railDeltaTo(slide)) < 2) return;
    scrollRailTo(slide);
  }

  if (rail) {
    markers.forEach(function (marker) {
      marker.addEventListener('click', function (event) {
        event.preventDefault();
        var index = parseInt(marker.getAttribute('data-thumb') || marker.getAttribute('data-dot'), 10);
        scrollRailTo(rail.querySelector('[data-slide="' + index + '"]'));
      });
    });

    var syncing = false;
    rail.addEventListener('scroll', function () {
      if (syncing) return;
      syncing = true;
      window.requestAnimationFrame(function () {
        var index = Math.round(rail.scrollLeft / rail.clientWidth);
        markers.forEach(function (marker) {
          var own = parseInt(marker.getAttribute('data-thumb') || marker.getAttribute('data-dot'), 10);
          marker.classList.toggle('is-current', own === index);
        });
        syncing = false;
      });
    }, { passive: true });
  }

  /* ── Variant selection ──────────────────────────────────────────────── */

  var optionGroups = Array.prototype.slice.call(
    form.querySelectorAll('[data-variant-options] .pdp__option')
  );

  function selectedOptions() {
    return optionGroups.map(function (group) {
      var pressed = group.querySelector('[aria-pressed="true"]');
      return pressed ? pressed.getAttribute('data-option-value') : null;
    });
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (options[j] !== null && v.options[j] !== options[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  // A value is unavailable when no variant carrying it can be bought at all —
  // Printful retiring a size, not a stock count. Only the *last* option group
  // is narrowed by the current selection; earlier ones stay browsable so you
  // can never paint yourself into a corner with nothing clickable.
  function refreshAvailability() {
    var chosen = selectedOptions();

    optionGroups.forEach(function (group, groupIndex) {
      var chips = group.querySelectorAll('[data-option-value]');
      Array.prototype.forEach.call(chips, function (chip) {
        var probe = chosen.slice();
        probe[groupIndex] = chip.getAttribute('data-option-value');
        if (groupIndex < optionGroups.length - 1) {
          for (var k = groupIndex + 1; k < probe.length; k++) probe[k] = null;
        }

        var possible = variants.some(function (v) {
          for (var j = 0; j < probe.length; j++) {
            if (probe[j] !== null && v.options[j] !== probe[j]) return false;
          }
          return v.available;
        });

        chip.classList.toggle('size-chip--unavailable', !possible);
        chip.disabled = !possible;
      });
    });
  }

  function updateVariant(variant) {
    var atc = form.querySelector('[data-atc]');
    var label = form.querySelector('[data-atc-label]');
    var barVariant = document.querySelector('[data-atc-bar-variant]');
    var barButton = document.querySelector('[data-atc-bar-button]');

    if (variant) {
      select.value = variant.id;
      Array.prototype.forEach.call(document.querySelectorAll('[data-price]'), function (el) {
        el.textContent = formatMoney(variant.price);
      });

      if (variant.featured_image && variant.featured_image.id) {
        showImageById(variant.featured_image.id);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    var buyable = !!(variant && variant.available);
    if (atc) atc.disabled = !buyable;
    if (barButton) barButton.disabled = !buyable;

    var name = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    if (label) {
      label.textContent = buyable
        ? 'Add to bag' + (name ? ' · ' + name : '')
        : (variant ? 'Unavailable in that size' : 'Pick a size');
    }
    if (barVariant) barVariant.textContent = name;
  }

  optionGroups.forEach(function (group, groupIndex) {
    group.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-option-value]');
      if (!chip || chip.disabled) return;

      Array.prototype.forEach.call(group.querySelectorAll('[data-option-value]'), function (other) {
        other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
      });

      // Narrowing an earlier option can strand a later one on a dead value;
      // move it to the first value that still resolves to a real variant.
      refreshAvailability();
      for (var i = groupIndex + 1; i < optionGroups.length; i++) {
        var later = optionGroups[i];
        var active = later.querySelector('[aria-pressed="true"]');
        if (!active || active.disabled) {
          var firstOpen = later.querySelector('[data-option-value]:not([disabled])');
          if (firstOpen) {
            Array.prototype.forEach.call(later.querySelectorAll('[data-option-value]'), function (other) {
              other.setAttribute('aria-pressed', other === firstOpen ? 'true' : 'false');
            });
          }
        }
      }

      updateVariant(findVariant(selectedOptions()));
    });
  });

  if (select && optionGroups.length) {
    form.classList.add('pdp__form--js');
    refreshAvailability();
    updateVariant(findVariant(selectedOptions()));
  }

  /* ── Sticky add-to-cart bar (phones) ────────────────────────────────── */

  var bar = document.querySelector('[data-atc-bar]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (bar && anchor) {
    // Two conditions, both needed. "Below the fold" is the trigger, but the bar
    // also has to get out of the way when the real button is on screen —
    // otherwise the page shows two identical Add to bag buttons at once.
    //
    // Measured straight from geometry rather than an IntersectionObserver: the
    // observer only reports on crossings, so its answer depends on the order
    // the page happened to be scrolled in, and a restored scroll position on
    // reload can leave it holding a stale one.
    var barTicking = false;

    function syncBar() {
      var box = anchor.getBoundingClientRect();
      var buttonOnScreen = box.bottom > 0 && box.top < window.innerHeight;
      var belowFold = window.scrollY > window.innerHeight * 0.5;
      var show = belowFold && !buttonOnScreen;

      bar.hidden = !show;
    }

    function queueSync() {
      if (barTicking) return;
      barTicking = true;
      window.requestAnimationFrame(function () {
        barTicking = false;
        syncBar();
      });
    }

    window.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync, { passive: true });
    syncBar();
  }
})();
